import { useQuery } from '@tanstack/react-query';

import { api } from '../api';

// resource -> permission keys
export function usePermissionCatalog() {
  return useQuery({
    queryKey: ['permission-catalog'],
    queryFn: () => api<Record<string, string[]>>(`/roles/permissions`),
    staleTime: Infinity,
  });
}
